<template>
  <div class="shadow" :style="computeStyle"></div>
</template>

<script>
export default {
  name: 'ShadowComponent',
  props: {
    height: {
      type: Number,
      default: 0.52 // 26px=>0.52rem
    },
    bgStartColor: {
      type: String,
      default: 'rgba(255,255,255,0)'
    },
    bgEndColor: {
      type: String,
      default: 'rgba(255,255,255,1)'
    },
    bgDirection: {
      type: String,
      default: '90deg'
    }
  },
  data() {
    return {}
  },
  computed: {
    computeStyle() {
      const bgImage =
        this.bgStartColor && this.bgEndColor
          ? `linear-gradient(${this.bgDirection}, ${this.bgStartColor}, ${this.bgEndColor} )`
          : 'none'
      return {
        backgroundImage: `${bgImage}`,
        height: `${this.height}rem`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shadow {
  position: absolute;
  left: -0.24rem;

  width: 0.24rem;
  height: 0.52rem;
}
</style>
